import { atomWithImmer } from "jotai/immer";
var initialValue = null;
export var systemConfigAtom = atomWithImmer(initialValue);
systemConfigAtom.debugLabel = "systemConfigAtom";